import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import apiUrls from "../../../api";
import { IAppLoaderAction } from "../../../common/state/loaderHandleMiddleware";
import { RootState } from "../../../common/state/store";

export interface IConfigs {
  welcomeVideoUrl: string;
}

export const getWelcomeVideoUrl = createAsyncThunk(
  "configs/getWelcomeVideoUrl",
  async (componentId: IAppLoaderAction) => {
    let response;

    await axios
      .get(`${apiUrls.configs.get}?_sort=id:DESC&_limit=-1`, {})
      .then((res) => {
        response = res.data.data[0].attributes.welcomeVideoUrl;
      })
      .catch((e) => {
        console.error(e);
        return e;
      });

    return response;
  },
);

const initialState: IConfigs = {
  welcomeVideoUrl: "",
};

export const configsSlice = createSlice({
  name: "configs",
  initialState,
  reducers: {
    clearAllConfigs: (state: IConfigs) => {
      state.welcomeVideoUrl = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getWelcomeVideoUrl.fulfilled, (state: IConfigs, { payload }: any) => {
      state.welcomeVideoUrl = payload;
    });
  },
});

export const configsReducer = configsSlice.reducer;

export const getCurrentWelcomeVideoUrl = (state: RootState) => state.configs.welcomeVideoUrl;

export const { clearAllConfigs } = configsSlice.actions;
